'use client';

import type { ReactNode } from 'react';
import { useOptimizely } from '@/main/lib/providers/OptimizelyProvider';

interface HideNavBarProps {
  children: ReactNode;
}

export const HideNavBar = ({ children }: HideNavBarProps) => {
  const { userFlags: userVariants } = useOptimizely();

  const hideTopicNavigation = (userVariants?.hideTopicMenu_mobile as { variant: string })?.variant === 'on';

  if (hideTopicNavigation) {
    return null;
  }

  return <>{children}</>;
};
